module.exports = __webpack_public_path__ + "static/media/logo-retina.4fbd7332.png";